import React from 'react';
import Alert from '../components/alert';

interface Props {
  isErrored: boolean;
  errorMsg?: string[];
}

export default function ErrorHandler(props: Props) {
  const { isErrored, errorMsg } = props;

  if (!isErrored) {
    return null;
  }

  return (
    <div className="alert-container">
      {!errorMsg ? (
        <Alert severity="error" sx={{ textAlign: 'center' }}>
          Something went wrong. Please refresh the page
        </Alert>
      ) : (
        errorMsg.map((message, index) => (
          <Alert key={index} severity="error" sx={{ textAlign: 'center' }}>
            {message}
          </Alert>
        ))
      )}
    </div>
  );
}
